import { cardViewStyle } from 'prose-core'

export const backgroundOptions = [
  { background: '#F0FAFF', darkBackground: false },
  { background: 'linear-gradient(90deg, #DBFBED 0%, #D6F9FB 100%)', darkBackground: false },
  { background: 'linear-gradient(90deg, #FFF2D1 0%, #FDE8FF 100%)', darkBackground: false },
  { background: 'linear-gradient(270deg, #55E9CB 0%, #83B1EB 100%)', darkBackground: true },
  {
    background:
      'url("https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1652788436/public/card-backgrounds/cardBackground1_p8xg9m.png") 50% 38% / cover no-repeat',
    darkBackground: true,
  },
  {
    background:
      'url("https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1652788438/public/card-backgrounds/cardBackground2_mj2mkv.jpg") 50% 38% / cover no-repeat',
    darkBackground: true,
    includeBoxShadow: true,
  },
  {
    background:
      'url("https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1652788437/public/card-backgrounds/cardBackground3_y0et5h.jpg") 22% 47% / 155% no-repeat',
    darkBackground: true,
  },
  {
    background:
      'url("https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1652788439/public/card-backgrounds/cardBackground4_sgtsdq.jpg") 50% 47% / cover no-repeat',
    includeBoxShadow: true,
    darkBackground: true,
  },
  {
    background:
      'url("https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1652788436/public/card-backgrounds/cardBackground5_n6po8t.jpg") 50% 38% / cover no-repeat',
    darkBackground: true,
  },
  {
    background:
      'url("https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1652788439/public/card-backgrounds/cardBackground6_dc6q2p.jpg") 50% 38% / cover no-repeat',
    darkBackground: true,
  },
]
export const fontOptions = [
  { value: 'Inter', label: 'Inter' },
  { value: 'IBM Plex Mono', label: 'Plex' },
  { value: 'publico-regular', label: 'Publico' },
  { value: 'Merriweather', label: 'Merriweather' },
]

export const layoutOptions: Array<cardViewStyle> = [
  { font: fontOptions[0].value, background: backgroundOptions[6].background, layout: 'default' },
  { font: fontOptions[0].value, background: backgroundOptions[5].background, layout: 'expanded' },
  { font: fontOptions[0].value, background: backgroundOptions[2].background, layout: 'expandedLargeAvatar' },
  { font: fontOptions[1].value, background: backgroundOptions[1].background, layout: 'expandedSmallAvatar' },
  { font: fontOptions[3].value, background: backgroundOptions[3].background, layout: 'splitPane' },
]
